export default __webpack_public_path__ + "static/media/attendance-absent.ff8cdd44.svg";